function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allId = exports.DropDownFilter = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _SectionIcon = _interopRequireDefault(require("../../images/Insights/icons/SectionIcon"));
var _View = require("../View");
var _reactNative = require("react-native-web");
var _SvgImage = require("../SvgImage");
var _reactNativeOutsidePress = _interopRequireDefault(require("react-native-outside-press"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var allId = exports.allId = 'all';
var DropDownFilter = exports.DropDownFilter = (0, _react.memo)(function (_ref) {
  var items = _ref.items,
    onClick = _ref.onClick,
    _ref$selectedItemId = _ref.selectedItemId,
    selectedItemId = _ref$selectedItemId === void 0 ? allId : _ref$selectedItemId,
    showAllLabel = _ref.showAllLabel,
    selectedItemPrefix = _ref.selectedItemPrefix,
    optionPrefix = _ref.optionPrefix;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isToggled = _useState2[0],
    setIsToggled = _useState2[1];
  var selectedItem = items.find(function (item) {
    return item.id === selectedItemId;
  });
  var handleClick = function handleClick(id) {
    setIsToggled(false);
    onClick(id);
  };
  var _onOutsidePress = (0, _react.useCallback)(function () {
    setIsToggled(false);
  }, []);
  return (0, _jsxRuntime.jsx)(_View.View, {
    style: styles.container,
    children: (0, _jsxRuntime.jsxs)(_reactNativeOutsidePress["default"], {
      onOutsidePress: _onOutsidePress,
      children: [(0, _jsxRuntime.jsxs)(_reactNative.Pressable, {
        onPress: function onPress() {
          return setIsToggled(!isToggled);
        },
        style: function style(state) {
          return [styles.button, state.focused && styles.button_focused, state.pressed && styles.button_pressed];
        },
        children: [(0, _jsxRuntime.jsxs)(_reactNative.Text, {
          style: styles.buttonText,
          children: [selectedItemPrefix, (selectedItem == null ? void 0 : selectedItem.label) || showAllLabel]
        }), (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
          image: require("../../images/Insights/icons/Triangle.svg"),
          width: 10,
          height: 10
        })]
      }), isToggled && (0, _jsxRuntime.jsx)(_View.View, {
        children: (0, _jsxRuntime.jsxs)(_View.View, {
          style: styles.menu,
          children: [(0, _jsxRuntime.jsx)(_View.View, {
            style: styles.menuTriangle
          }), (0, _jsxRuntime.jsx)(_View.View, {
            style: styles.menuTriangleCover
          }), showAllLabel && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(0, _jsxRuntime.jsx)(_reactNative.Pressable, {
              style: function style(state) {
                return [styles.menuButton, styles.firstMenuItem, state.hovered && styles.menuButtonHover, state.focused && styles.button_focused, state.pressed && styles.button_pressed];
              },
              onPress: function onPress() {
                return handleClick(allId);
              },
              children: (0, _jsxRuntime.jsxs)(_reactNative.Text, {
                style: styles.menuButtonText,
                children: [optionPrefix, showAllLabel]
              })
            }), (0, _jsxRuntime.jsx)(_View.View, {
              style: styles.menuDivider
            })]
          }), items.map(function (item, index) {
            return (0, _jsxRuntime.jsxs)(_reactNative.Pressable, {
              style: function style(state) {
                return [styles.menuButton, state.hovered && styles.menuButtonHover, state.focused && styles.button_focused, state.pressed && styles.button_pressed, index === items.length - 1 && styles.lastMenuItem];
              },
              onPress: function onPress() {
                return handleClick(item.id);
              },
              children: [(0, _jsxRuntime.jsxs)(_reactNative.Text, {
                style: styles.menuButtonText,
                children: [optionPrefix, item.label]
              }), (0, _jsxRuntime.jsx)(_SectionIcon["default"], {
                type: item.id
              })]
            }, index);
          })]
        })
      })]
    })
  });
});